import { useQuery } from '@tanstack/react-query';

import { getLoans } from '~apis/cash-flow-overview/loans';
import { getTrends } from '~apis/cash-flow-overview/trend';

export const CashFlowQueryKey = {
  default: () => ['cashFlow'],
  loan: () => [CashFlowQueryKey.default, 'loan'],
  trends: () => [CashFlowQueryKey.default, 'trends'],
};

export function useGetLoans({ companyId }: { companyId: string }) {
  return useQuery({
    queryKey: [CashFlowQueryKey.default(), companyId],
    queryFn: () => getLoans({ companyId }),
    enabled: !!companyId,
  });
}

export function useGetTrends({
  companyId,
  startDate,
  endDate,
}: {
  companyId: string;
  startDate: string;
  endDate: string;
}) {
  return useQuery({
    queryKey: [CashFlowQueryKey.trends(), companyId, startDate, endDate],
    queryFn: () => getTrends({ companyId, startDate, endDate }),
    enabled: !!companyId,
  });
}
